<template>
  <div class="nav-footer">
    <span v-if="tenantInfo.name">主办单位：{{tenantInfo.name}}</span>
    <span v-if="tenantInfo.footer">{{tenantInfo.footer}}</span>
    <span></span>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      activeIndex: '1',
      tenantInfo: {},
    }
  },
  created() {
    this.tenantInfo = this.$root.tenantInfo;
  },
  mounted() {
    this.$bus.$on("Update_TenantInfo", data => {
      this.tenantInfo = this.$root.tenantInfo;
    });
  },
  beforeDestroy() {
    this.$bus.$off('Update_TenantInfo')
  },
  methods: {

  },
}
</script>

<style lang="scss">
.nav-footer {
  width: 100%;
  color: #333;
  // background-color:#f0f0f0;
  z-index: 1;
  text-align: center;
  border-top: 1px solid #e8e8e8;
  height: 35px;
  line-height: 35px;
  position: absolute;
  bottom: 0;
  left: 0;
  overflow: hidden;
  box-sizing: border-box;
  font-size: 14px;
}
.nav-footer a {
  color: #333;
}
.nav-footer a:hover {
  text-decoration: underline;
}
.nav-footer span {
  margin: 0 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/pc/components/shared/NavFooter.vue